import { Enum } from './Enum';

export class CandidateField extends Enum {
  translationKey = 'candidateField';

  static readonly asArray: CandidateField[] = [];

  static readonly byKey: { [name: string]: CandidateField } = {};

  static readonly ADDRESS_1 = new CandidateField('Address 1');

  static readonly ADDRESS_2 = new CandidateField('Address 2');

  static readonly CITY = new CandidateField('City');

  static readonly EMAIL = new CandidateField('Email');

  static readonly EMERGENCY_CONTACT = new CandidateField('Emergency Contact');

  static readonly HCP = new CandidateField('HCP');

  static readonly LIVES_WITH_MEMBER = new CandidateField('Lives with member');

  static readonly PHONE_NUMBER_1 = new CandidateField('Phone Number 1');

  static readonly PHONE_NUMBER_2 = new CandidateField('Phone Number 2');

  static readonly PHONE_NUMBER_3 = new CandidateField('Phone Number 3');

  static readonly PHONE_TYPE_1 = new CandidateField('Phone Type 1');

  static readonly PHONE_TYPE_2 = new CandidateField('Phone Type 2');

  static readonly PHONE_TYPE_3 = new CandidateField('Phone Type 3');

  static readonly PREFERRED_CONTACT = new CandidateField('Preferred contact');

  static readonly PREFERRED_LANGUAGE = new CandidateField('Preferred Language');

  static readonly SECONDARY_LANGUAGE = new CandidateField('Secondary Language');

  static readonly STATE = new CandidateField('State');

  static readonly SUBTYPE_RELATIONSHIP_SPECIALITY = new CandidateField(
    'Subtype (Relationship/Speciality)',
  );

  static readonly TYPE_ROLE_TYPE = new CandidateField('Type (Role/Type)');

  static readonly ZIP_CODE = new CandidateField('Zip Code');

  constructor(public readonly value: string) {
    super();
    CandidateField.asArray.push(this);
    CandidateField.byKey[value] = this;
  }

  toString(): string {
    return this.valueOf();
  }
}

export default CandidateField;
